import React from 'react';
import ImageZoom from 'react-medium-image-zoom';
import coverImg from '../../imgs/FacilityManage/coverImg3.jpg';
import img1 from '../../imgs/FacilityManage/case1_1.png';
import img2 from '../../imgs/FacilityManage/case1_2.png';
import img3 from '../../imgs/FacilityManage/setting.png';
import img4 from '../../imgs/FacilityManage/alert.png';
import img5 from '../../imgs/FacilityManage/schedule.png';
import img6 from '../../imgs/FacilityManage/quick-control.png';
import img7 from '../../imgs/FacilityManage/floorplan.png';
import systemImg from '../../imgs/FacilityManage/systemImg.png';
import personaImg from '../../imgs/FacilityManage/personatom.jpg';
import idea1 from '../../imgs/FacilityManage/idea1.jpg';
import idea2 from '../../imgs/FacilityManage/idea2.jpg';
import idea3 from '../../imgs/FacilityManage/idea3.jpg';
import taskanalysis from '../../imgs/FacilityManage/taskanalysis.png';
import wireframe1 from '../../imgs/FacilityManage/wireframe1.png';
import wireframe3 from '../../imgs/FacilityManage/wireframe3.png';
import useCase from '../../imgs/FacilityManage/use-case.png';

const FacilityManage = () => (
  <div className="caseBody">
    <section className="head">
      <h2>Facility Manager Interface for Whole Building Control and Monitor</h2>
      <p className="caseIntro">Client: Lutron Electronics Company</p>
      <img className="img-responsive img-centered" src={coverImg} alt="" />
    </section>

    <section className="mainSec">
      <div className="left">
        <h3 id="overview">Project Overview</h3>
      </div>
      <div className="right">
        <h4>GOALS</h4>
        <p className="content-p">
          This project aims to develop a mobile application corresponding to our
          client’s existing software - Quantum Vue, which allows facility
          managers to manage their electric light and daylight for maximum
          energy efficiency, comfort and productivity.
        </p>
        <p className="content-p">
          With the launching of the final product, a facility manager will be
          able to control electric lights and shades, as well as configure,
          monitor, analyze, and report on the lighting system inside the
          building.
        </p>
        <ImageZoom
          image={{
            src: img1,
            alt: 'site audit',
            className: 'img-responsive img-centered'
          }}
        />
        <h4>MY ROLES</h4>
        <p className="content-p">
          User Experience Designer - I took a lead role in drafting interview
          protocol, individually created several work models (pictured), and
          wrote a portion of the final analysis.
        </p>
        <p className="content-p">
          Project Manager - I was the client liaison and project manager. I
          helped manage scope, timelines, and team/client communication.
        </p>
        <h4>HIGHLIGHTS</h4>
        <p className="content-p p-check">
          I handled all the communication (emails, video call and in-person)
          with clients and reached out to interviewees.
        </p>
        <p className="content-p p-check">
          I kept everyone on the same page, make sure project was carried out as
          planned.
        </p>
        <p className="content-p p-check">
          We wrote interview script, consent form and conducted interviews with
          facility managers on campus.
        </p>
        <p className="content-p p-check">
          We gathered feedback and generated insigts from research, created
          personas and diagrams that guided us through the design process.
        </p>
        <p className="content-p p-check">
          I led the design - I made mockups and protypes based on whiteboarding
          and sketching. I also created a fully click-through prototype.
        </p>
        <h4>TOOLS</h4>
        <p className="content-p">Balsamiq, Sketch, Photoshop, Marvelapp</p>
      </div>
    </section>
    <section className="mainSec">
      <div className="left">
        <h3 id="projectactivities">Project Activities</h3>
      </div>
      <div className="right">
        <h4 className="sub-header">RESEARCH</h4>
        <p className="content-p">
          I conducted some research on current facility management system,
          especially lightning control system. Studying different systems
          provided overall cognition of how to design a management platform,
          especially figuring out significant functions and workflow.
        </p>
        <p className="content-p">
          After research, we began the interview part. We explored user’s
          attitude and how they thought about the problem, which led to
          clarifying user’s need and pain points. I interviewed several facility
          managers of Cornell and observed how current facility management
          systems worked in Cornell. From observing usage of Automated Logic
          system applied in Gates Hall and how facility manager worked, we
          summarized our findings and transferred collected data into persona
          design.
        </p>
        <ImageZoom
          image={{
            src: systemImg,
            alt: 'system',
            className: 'img-responsive img-centered'
          }}
        />
        <h4 className="sub-header">PERSONA</h4>
        <p className="content-p">
          After investigating the current platform and the essential requirement
          from facility manager, I simulated the scenarios by adapting them into
          persona.
        </p>
        <ImageZoom
          image={{
            src: personaImg,
            alt: 'persona',
            className: 'img-responsive img-centered'
          }}
        />
        <h4 className="sub-header">TASK ANALYSIS</h4>
        <p className="content-p">
          After interview we took one more step forward to learn how facility
          managers are actually interacting with their current system. By
          observing ordinary users in action, we understood in detail how they
          perform their tasks and achieve their intended goals. Through the
          tasks analysis, I figured and identified the tasks that the
          applications must support and our team refined or redefined the site’s
          navigation by determining the appropriate content scope.
        </p>
        <ImageZoom
          image={{
            src: taskanalysis,
            alt: 'task analysis',
            className: 'img-responsive img-centered'
          }}
        />
        <h4 className="sub-header">USA CASE</h4>
        <p className="content-p">
          {`The product also has impact on other groups, such as faculties/students and energy managers who are indirect beneficiaries of it. To analyze the users’ needs from their angle, I created several use case and we identified which features should be prioritized in our product.`}
        </p>
        <ImageZoom
          image={{
            src: useCase,
            alt: 'use case',
            className: 'img-responsive img-centered'
          }}
        />
        <h4 className="sub-header">WORKFLOW AND WIREFRAME DESIGN</h4>
        <p className="content-p">
          The workflow demonstrated the hierarchy and structure of the
          application. We took consideration about the priority mission of our
          target users. Therefore, the very first step of using this application
          was to set your preference over the features.
        </p>
        <h4 className="sub-header">
          LOW FIDELITY PROTOTYPE DESIGN & USER TESTING
        </h4>
        <h6>(a) Prototype Design</h6>
        <p className="content-p">
          Based on our research, we initiated low fidelity prototype - first on
          white board and then I migrated the design onto paper. I took in
          charge of the design and made them interactive for testing purpose.
        </p>
        <ImageZoom
          image={{
            src: idea1,
            alt: 'idea 1',
            className: 'img-responsive img-centered'
          }}
        />
        <ImageZoom
          image={{
            src: idea2,
            alt: 'idea 2',
            className: 'img-responsive img-centered'
          }}
        />
        <ImageZoom
          image={{
            src: idea3,
            alt: 'idea 3',
            className: 'img-responsive img-centered'
          }}
        />
        <ImageZoom
          image={{
            src: wireframe1,
            alt: 'wireframe 1',
            className: 'img-responsive img-centered'
          }}
        />
        <ImageZoom
          image={{
            src: wireframe3,
            alt: 'wireframe 2',
            className: 'img-responsive img-centered'
          }}
        />
        <a
          className="demo-link"
          href="https://marvelapp.com/1f1fj27"
          rel="noopenner noreferrer"
          target="_blank"
        >
          Paper prototype link →
        </a>
        <br />
        <br />
        <ImageZoom
          image={{
            src: img2,
            alt: 'paper prototype',
            className: 'img-responsive img-centered'
          }}
        />
        <h6>(b) User testing</h6>
        <p className="content-p">
          {`We conducted a user testing, evaluating the product by testing it with representative users. Through user testing, I identified usability problems, collected qualitative and quantitative data and determined the participant's satisfaction with the product.`}
        </p>
        {/* <h4 className="sub-header">7) Wireframe</h4>
        <img className="img-responsive img-centered" src={wireFrameImg} alt="" /> */}
      </div>
    </section>
    <section className="mainSec">
      <div className="left">
        <h3 id="outcomes">Outcomes</h3>
      </div>
      <div className="right">
        <p className="content-p">
          According to our interview and analysis, we prioritized the features
          that the users favored the most. We came up with several iterations
          and evaluated them based on previously collected data. Following is a
          display of the user interface:
        </p>
        <a
          className="demo-link"
          href="https://marvelapp.com/1362i7e"
          rel="noopenner noreferrer"
          target="_blank"
        >
          High fidelity interactive prototype demo →
        </a>
        <br />
        <br />
        <ImageZoom
          image={{
            src: img3,
            alt: '',
            className: 'img-responsive img-centered'
          }}
        />
        <ImageZoom
          image={{
            src: img4,
            alt: '',
            className: 'img-responsive img-centered'
          }}
        />
        <ImageZoom
          image={{
            src: img5,
            alt: '',
            className: 'img-responsive img-centered'
          }}
        />
        <ImageZoom
          image={{
            src: img6,
            alt: '',
            className: 'img-responsive img-centered'
          }}
        />
        <ImageZoom
          image={{
            src: img7,
            alt: '',
            className: 'img-responsive img-centered'
          }}
        />
      </div>
    </section>
  </div>
);

export default FacilityManage;



// WEBPACK FOOTER //
// ./src/Modules/Case/FacilityManage.js